import type { CountryValue, GreaterRegionValue, RegionValue } from "domains/moderate/sources/constants";

// TODO: Move the Country, Region and Greater Region data to BE in the future

export const COUNTRY_TO_REGION_MAPPING: Record<CountryValue, RegionValue> = {
  Afghanistan: "South Asia",
  Albania: "Central/Eastern Europe",
  Algeria: "North Africa",
  "American Samoa": "Asia Pacific",
  Andorra: "Western Europe",
  Angola: "Sub-saharan Africa",
  Anguilla: "North America",
  Antartica: "Antarctica",
  "Antigua and Barbuda": "North America",
  Argentina: "Latin America",
  Armenia: "Central/Eastern Europe",
  Aruba: "North America",
  Australia: "Australasia",
  Austria: "Western Europe",
  Azerbaijan: "Central/Eastern Europe",
  Bahamas: "North America",
  Bahrain: "Middle East",
  Bangladesh: "South Asia",
  Barbados: "North America",
  Belarus: "Central/Eastern Europe",
  Belgium: "Western Europe",
  Belize: "Latin America",
  Benin: "Sub-saharan Africa",
  Bermuda: "North America",
  Bhutan: "South Asia",
  Bolivia: "Latin America",
  "Bosnia and Herzegovina": "Central/Eastern Europe",
  Botswana: "Sub-saharan Africa",
  "Bouvet Island": "North America",
  Brazil: "Latin America",
  "British Indian Ocean Territory": "Asia Pacific",
  "Brunei Darussalam": "Asia Pacific",
  Bulgaria: "Central/Eastern Europe",
  "Burkina Faso": "Sub-saharan Africa",
  Burundi: "Sub-saharan Africa",
  Cambodia: "Asia Pacific",
  Cameroon: "Sub-saharan Africa",
  Canada: "North America",
  "Cape Verde": "Sub-saharan Africa",
  "Cayman Islands": "North America",
  "Central African Republic": "Sub-saharan Africa",
  Chad: "Sub-saharan Africa",
  Chile: "Latin America",
  "Christmas Islands": "Asia Pacific",
  "Cocos (Kelling) Islands": "Asia Pacific",
  Colombia: "Latin America",
  Comoros: "Sub-saharan Africa",
  Congo: "Sub-saharan Africa",
  "Cook Islands": "Asia Pacific",
  "Costa Rica": "Latin America",
  "Côte d'Ivoire": "Sub-saharan Africa",
  Croatia: "Central/Eastern Europe",
  Cuba: "Latin America",
  Cyprus: "Western Europe",
  "Czech Republic": "Central/Eastern Europe",
  "Democratic People's Republic of Korea": "Asia Pacific",
  "Democratic Republic of Congo": "Sub-saharan Africa",
  Denmark: "Western Europe",
  Djibouti: "Sub-saharan Africa",
  "Dominican Republic": "Latin America",
  Ecuador: "Latin America",
  Egypt: "Middle East",
  "El Salvador": "Latin America",
  "Equatorial Guinea": "Sub-saharan Africa",
  Eritrea: "Sub-saharan Africa",
  Estonia: "Central/Eastern Europe",
  Ethiopia: "Sub-saharan Africa",
  "Falklands Islands (Malvinas)": "Latin America",
  "Faroe Islands": "Western Europe",
  Fiji: "Asia Pacific",
  Finland: "Western Europe",
  "Former Yugoslav Republic of Macedonia": "Central/Eastern Europe",
  France: "Western Europe",
  "France, Metropolitan": "Western Europe",
  "French Guiana": "Latin America",
  "French Polynesia": "Asia Pacific",
  "French Southern Territories": "Antarctica",
  Gabon: "Sub-saharan Africa",
  Gambia: "Sub-saharan Africa",
  Georgia: "Central/Eastern Europe",
  Germany: "Western Europe",
  Ghana: "Sub-saharan Africa",
  Gibraltar: "Western Europe",
  Greece: "Western Europe",
  Greenland: "Western Europe",
  Grenada: "North America",
  Guadeloupe: "North America",
  Guam: "Asia Pacific",
  Guatemala: "Latin America",
  Guinea: "Sub-saharan Africa",
  "Guinea-Bissau": "Sub-saharan Africa",
  Guyana: "Latin America",
  Haiti: "North America",
  "Heard and Mc Donald Islands": "Antarctica",
  Honduras: "Latin America",
  "Hong Kong SAR": "Greater China",
  Hungary: "Central/Eastern Europe",
  Iceland: "Western Europe",
  India: "South Asia",
  Indonesia: "Asia Pacific",
  Iraq: "Middle East",
  Ireland: "Western Europe",
  "Islamic Republic of Iran": "Middle East",
  Israel: "Middle East",
  Italy: "Western Europe",
  Jamaica: "North America",
  Japan: "Japan",
  Jordan: "Middle East",
  Kazakhstan: "Central/Eastern Europe",
  Kenya: "Sub-saharan Africa",
  Kiribati: "Asia Pacific",
  Kosovo: "Central/Eastern Europe",
  Kuwait: "Middle East",
  "Kyrgyz Republic": "Central/Eastern Europe",
  Laos: "Asia Pacific",
  Latvia: "Central/Eastern Europe",
  Lebanon: "Middle East",
  Lesotho: "Sub-saharan Africa",
  Liberia: "Sub-saharan Africa",
  Libya: "North Africa",
  Liechtenstein: "Western Europe",
  Lithuania: "Central/Eastern Europe",
  Luxembourg: "Western Europe",
  "Macao SAR": "Greater China",
  Madagascar: "Sub-saharan Africa",
  Malawi: "Sub-saharan Africa",
  Malaysia: "Asia Pacific",
  Maldives: "South Asia",
  Mali: "Sub-saharan Africa",
  Malta: "Western Europe",
  "Marshall Islands": "Asia Pacific",
  Martinique: "North America",
  Mauritania: "North Africa",
  Mauritius: "Sub-saharan Africa",
  Mayotte: "Asia Pacific",
  Mexico: "Latin America",
  Micronesia: "Asia Pacific",
  Moldova: "Central/Eastern Europe",
  Monaco: "Western Europe",
  Mongolia: "Asia Pacific",
  Montenegro: "Central/Eastern Europe",
  Montserrat: "North America",
  Morocco: "North Africa",
  Mozambique: "Sub-saharan Africa",
  Myanmar: "Asia Pacific",
  Namibia: "Sub-saharan Africa",
  Nauru: "Asia Pacific",
  Nepal: "South Asia",
  Netherlands: "Western Europe",
  "Netherlands Antilles": "North America",
  "New Caledonia": "Asia Pacific",
  "New Zealand": "Australasia",
  Nicaragua: "Latin America",
  Niger: "Sub-saharan Africa",
  Nigeria: "Sub-saharan Africa",
  Niue: "Asia Pacific",
  "Norfolk Islands": "Asia Pacific",
  "Northern Cyprus": "Western Europe",
  "Northern Mariana Islands": "Asia Pacific",
  Norway: "Western Europe",
  Oman: "Middle East",
  Pakistan: "South Asia",
  Palau: "Asia Pacific",
  "Palestinian Territories": "Middle East",
  Panama: "Latin America",
  "Papua New Guinea": "Asia Pacific",
  Paraguay: "Latin America",
  "People's Republic of China": "Greater China",
  Peru: "Latin America",
  Philippines: "Asia Pacific",
  Pitcairn: "Asia Pacific",
  Poland: "Central/Eastern Europe",
  Portugal: "Western Europe",
  "Puerto Rico": "Latin America",
  Qatar: "Middle East",
  "Republic of Korea": "Asia Pacific",
  Reunion: "Sub-saharan Africa",
  Romania: "Central/Eastern Europe",
  "Russian Federation": "Russia",
  Rwanda: "Sub-saharan Africa",
  "Saint Kitts and Nevis": "North America",
  "Saint Lucia": "North America",
  "Saint Vincent and The Grenadines": "North America",
  Samoa: "Asia Pacific",
  "San Marino": "Western Europe",
  "Sao Tome and Principe": "Sub-saharan Africa",
  "Saudi Arabia": "Middle East",
  Senegal: "Sub-saharan Africa",
  Serbia: "Central/Eastern Europe",
  Seychelles: "Sub-saharan Africa",
  "Sierra Leone": "Sub-saharan Africa",
  Singapore: "Asia Pacific",
  Slovakia: "Central/Eastern Europe",
  Slovenia: "Central/Eastern Europe",
  "Solomon Islands": "Asia Pacific",
  Somalia: "Sub-saharan Africa",
  Somaliland: "Sub-saharan Africa",
  "South Africa": "Sub-saharan Africa",
  "South Georgia and the South Sandwich Islands": "Latin America",
  "South Sudan": "Sub-saharan Africa",
  Spain: "Western Europe",
  "Sri Lanka": "South Asia",
  "St. Helena": "Sub-saharan Africa",
  "St. Pierre and Miquelon": "North America",
  Sudan: "Sub-saharan Africa",
  Suriname: "Latin America",
  "Svalbard and Jan Mayen Islands": "Western Europe",
  Swaziland: "Sub-saharan Africa",
  Sweden: "Western Europe",
  Switzerland: "Western Europe",
  Syria: "Middle East",
  "Taiwan, China": "Greater China",
  Tajikistan: "Central/Eastern Europe",
  Tanzania: "Sub-saharan Africa",
  Thailand: "Asia Pacific",
  "Timor-Leste": "Asia Pacific",
  Togo: "Sub-saharan Africa",
  Tokelau: "Asia Pacific",
  Tonga: "Asia Pacific",
  "Trinidad and Tobago": "North America",
  Tunisia: "North Africa",
  Turkey: "Central/Eastern Europe",
  Turkmenistan: "Central/Eastern Europe",
  "Turks and Caicos Islands": "North America",
  Tuvalu: "Asia Pacific",
  Uganda: "Sub-saharan Africa",
  Ukraine: "Central/Eastern Europe",
  "United Arab Emirates": "Middle East",
  "United Kingdom": "Western Europe",
  "United States Minor Outlying Islands": "North America",
  Unknown: "Unknown",
  Uruguay: "Latin America",
  USA: "North America",
  Uzbekistan: "Central/Eastern Europe",
  Vanuatu: "Asia Pacific",
  "Vatican City State": "Western Europe",
  Venezuela: "Latin America",
  "Viet Nam": "Asia Pacific",
  "Virgin Islands (British)": "North America",
  "Virgin Islands (U.S.)": "North America",
  "Wallis and Futuna Islands": "Asia Pacific",
  Yemen: "Middle East",
  Zambia: "Sub-saharan Africa",
  Zimbabwe: "Sub-saharan Africa",
} as const;

export const REGION_TO_GREATER_REGION_MAPPING: Record<RegionValue, GreaterRegionValue> = {
  "South Asia": "Asia",
  "Central/Eastern Europe": "Europe",
  "North Africa": "Middle East/North Africa",
  "Asia Pacific": "Asia",
  "Western Europe": "Europe",
  "Sub-saharan Africa": "Middle East/North Africa",
  Antarctica: "Asia",
  Australasia: "Asia",
  "Middle East": "Middle East/North Africa",
  "Greater China": "Asia",
  Japan: "Asia",
  Russia: "Europe",
  Unknown: "Unknown",
  "North America": "Unknown",
  "Latin America": "Unknown",
} as const;
